<template>
  <div
      class="table-context-menu"
      @click.stop
      @contextmenu.prevent
  >
    <layer-context-menu
        :visible="visible"
        :x="x"
        :y="y"
        :items="items"
        @select="$emit('select', $event)"
    />
  </div>
</template>

<script>
import LayerContextMenu from '@/components/Layer/LayerContextMenu.vue';

export default {
  name:       'TableContextMenu',
  components: { LayerContextMenu },
  props:      {
    visible: { type: Boolean, default: false },
    x:       { type: Number, default: 0 },
    y:       { type: Number, default: 0 },
    items:   { type: Array, default: () => [] },
  },
  watch: {
    visible(isVisible) {
      if (isVisible) {
        this.$nextTick(() => this.mountToBody());
      }
    },
  },
  mounted() {
    this.mountToBody();
  },
  updated() {
    if (this.visible) {
      this.mountToBody();
    }
  },
  beforeDestroy() {
    if (this.$el && this.$el.parentNode === document.body) {
      document.body.removeChild(this.$el);
    }
  },
  methods: {
    mountToBody() {
      if (this.$el && this.$el.parentNode !== document.body) {
        document.body.appendChild(this.$el);
      }
    },
  },
};
</script>
